import React from "react";
import { Box, Typography } from "@mui/material";
import { formatMobileSlidingDraftValidThroughLabel } from "../lib/draftAccess";
import { mono, pageSx, slidingTextMuted } from "../styles/mainStyles";
import { SLIDING_PUZZLE_QUEST_TITLE } from "../routes";

export default function SlidingDraftExpiredPage() {
    const validThrough = formatMobileSlidingDraftValidThroughLabel();

    return (
        <Box sx={{ ...pageSx, alignItems: "center", justifyContent: "center", textAlign: "center" }}>
            <Typography
                component="h1"
                sx={{
                    fontFamily: mono,
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    letterSpacing: "0.06em",
                    mb: 2,
                }}
            >
                {SLIDING_PUZZLE_QUEST_TITLE.toUpperCase()}
            </Typography>
            <Typography
                sx={{
                    fontFamily: mono,
                    fontWeight: 700,
                    fontSize: "1rem",
                    mb: 1.5,
                }}
            >
                Prototype expired
            </Typography>
            <Typography sx={{ fontFamily: mono, color: slidingTextMuted, maxWidth: 360 }}>
                This mobile-draft prototype was only available through {validThrough}.
            </Typography>
        </Box>
    );
}
